import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Flight } from '@ibe/models';
import { SidebarService } from '@ibe/services/ui';
import { Observable, Subscription } from 'rxjs';
import { INDRABookingService } from "@ibe.services/booking.indra.service";
import { INDRAPax } from '@ibe.models/pax.indra.model.lib';
import { BRAND_DESCRIPTION_TOP_EXECUTIVE, BRAND_DESCRIPTION_EXECUTIVE, ANCILLARY_GROUP_DEPORTEES_LIST, ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST, SSR_CODE_UNACCOMPANIED_MINOR, BRAND_NAMES_MAP, SPECIAL_CASE_MARKET_LANGUAGE_MAP, SESSION_VAR_KEY_LANGUAGE, DEFAULT_LANGUAGE, SESSION_VAR_KEY_MARKET, DEFAULT_MARKET } from '@ibe.config';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRATotalSummaryService } from '@ibe.services/total-summary.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-details-loyalty-miles',
	templateUrl: './details-loyalty-miles.indra.component.html',
	styleUrls: ['./details-loyalty-miles.component.scss']
})
export class INDRADetailsLoyaltyMilesComponent implements OnInit, OnDestroy {


	flight: any;
	flightRouteInput: any;
	flight$: Observable<Flight>;
	_hasEdit = false;
	flightIdentifier: string;
	passengers: INDRAPax[] = [];

	LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE = 'whatsIncludedSidebars.'
	LOCAL_TRANSLATION_DETAILED_LOYALTY_MILES = this.LOCAL_TRANSLATION_WHATS_INCLUDED_MODULE + 'detailsLoyaltyMiles.'

	hasDeporteeFlag = false; // this will be utilized for detecting deportee/under lawful custody ancillary on prm
	hasMedicalAssistanceFlag = false; // this will be utilized for detecting requested medical assistance on prm
	hasUMNRFlag = false; // this will be utilized for detecting if unaccompnied minor SSR was included on prm
	hasAllFrequentFlyerPassenger = true; // this will be utilized to identify whether the PNR contains partial or all frequent flyer passengers

	booking_trip;
	IfAllPassengersAreChildren = false;
	isFlagged: boolean = false;
	totalSummarySubscription: Subscription;
	
	isBookingView: boolean = false;
	isReviewTTTCompletion: boolean = false;
	brandDescription: string;
	
	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected bookingService: INDRABookingService,
		private bfmStorageService: INDRABFMDataStorageService,
		private bfmDataStorage: INDRABFMDataStorageService,
		private totalSummaryService: INDRATotalSummaryService,
		private bookingSearchService: INDRABookingSearchService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
	) { 
		if (this.router.url.includes('/my-bookings/view/')) this.isBookingView = true;
		if (this.router.url.includes('/review-your-trip/deeplink/')) this.isReviewTTTCompletion = true;
	}


	ngOnInit() {
		this.flightIdentifier = this.route.snapshot.paramMap.get('flight');
		this.flight = this.bookingService.INDRA_getBookedFlight(this.flightIdentifier);
		this.flightRouteInput = this.flight;

		this.passengers = this.bookingService.INDRA_getPaxInfo();
		this.booking_trip = this.bfmStorageService.activeBooking;
		this.IfAllPassengersAreChildren = this.bookingService.INDRA_checkIfAllPassengersAreChildren(this.passengers);
		this.brandDescription = this.INDRA_getBrandDescription();

		this.passengers.forEach(pax => {
			if (pax.prm) {
				let deporteePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_DEPORTEES_LIST.includes(prmItem.type));
				let medicalAssistancePRM = pax.prm.filter(prmItem => ANCILLARY_GROUP_MEDICAL_ASSISTANCE_LIST.includes(prmItem.type));
				let umnrPRM = pax.prm.filter(prmItem => SSR_CODE_UNACCOMPANIED_MINOR == prmItem.type);

				if (deporteePRM.length > 0) {
					this.hasDeporteeFlag = true;
				}

				if (medicalAssistancePRM.length > 0) {
					this.hasMedicalAssistanceFlag = true;
				}

				if (umnrPRM.length > 0) {
					this.hasUMNRFlag = true;
				}
			}

			if (!pax.FFid || !pax.FFnum) {
				this.hasAllFrequentFlyerPassenger = false;
			}
		});
		this.totalSummarySubscription = this.totalSummaryService.INDRA_getObservableTotalSummary().subscribe(
			data => {
				if (data) {
					this.isFlagged = this.bookingService.INDRA_isUnavailableFlight(this.flight.idFlight, data);
				}
			}
		);
	}

	INDRA_capitalize(str: string) {
		if (str.length > 0) {
			return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		}
		return '';
	}

	INDRA_printPassengerName(pax: INDRAPax) {
		return this.INDRA_capitalize(pax.name) + ' ' + this.INDRA_capitalize(pax.surname);
	}

	INDRA_getLoyaltyMiles(flightId: string, tier: string, flightCardId : string) {
		return this.bookingService.INDRA_getLoyaltyMilesPerTierByFlightCardId(flightId,tier,flightCardId);
	}

	INDRA_getLoyaltyMilesPerTierByFlightCardId(flightId: string, tier: string,flightCardId : string) {
		return this.bookingService.INDRA_getLoyaltyMilesPerTierByFlightCardId(flightId, tier,flightCardId);
	}


	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	INDRA_handleClose() { this.closeSidebar(); }


	INDRA_printBrand() {
		return this.brandDescription;
	}

	INDRA_showUpgrade() {
		// let brand = this.INDRA_printBrand();
		return !(this.brandDescription === BRAND_DESCRIPTION_TOP_EXECUTIVE || this.brandDescription === BRAND_DESCRIPTION_EXECUTIVE || this.hasDeporteeFlag || this.hasMedicalAssistanceFlag || this.hasUMNRFlag || this.IfAllPassengersAreChildren) && !this.isFlagged;
	}

	INDRA_getTranslationKey(lastKey: string, keyType: string) {
		return this.LOCAL_TRANSLATION_DETAILED_LOYALTY_MILES + keyType + "." + lastKey;
	}

	INDRA_handleOpenDetailsSidebar(id) {
		// this.sidebarService.openSidebar(['passengers', { pnr: this.booking_trip.data.pnr, id,origin:'miles' }]);
		this.sidebarService.openSidebar(['passengers', { pnr: this.booking_trip.data.pnr, id }]);

	}

	INDRA_upgradeWithCash() {
		let activeBookedTrip = this.bfmDataStorage.INDRA_getActiveBookedTrip();
		let link = '/my-bookings/upgrade-with-cash/' + activeBookedTrip.data.pnr;
		let params = { flight: this.flight['assignedFlightId'] }
		this.sidebarService.closeSidebar();
		this.bookingService.INDRA_linkRouteData(link, params);
	}

	ngOnDestroy() {
		if (this.totalSummarySubscription) this.totalSummarySubscription.unsubscribe();
	}
	
	INDRA_getBrandDescription() {
		if (this.isBookingView || this.isReviewTTTCompletion) {
			if (!this.flight.fareFamily) return '';
			const brandCode = this.bookingSearchService.INDRA_getBrandCodeFromAmadeus(this.flight.fareFamily);
			return brandCode ? BRAND_NAMES_MAP[brandCode] : '';
		} else {
			this.bookingService.INDRA_getBrand(this.flightIdentifier.toString());
		}
	}

	INDRA_goToUrl(key: string) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ?
								sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate, '_blank');
	}
}
